// extracted by mini-css-extract-plugin
export default {"root":"LinksPage_root__1053b"};